import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'cuponesEC',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],
      comercios_f: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      'rowCallback': function (row, data, index) { },
    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return '/billeteras/pix/movimientos?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta + '&estado=' + this.f_c.estado
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/billeteras/pix/movimientos', this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            response.data.data.forEach(element => {
              element[7] = this.num_to_many(element[7]);
              element[16] = this.num_to_many(element[16]);
              element[17] = this.num_to_many(element[17]);
              element[18] = this.num_to_many(element[18]);
              element[19] = this.num_to_many(element[19]);
              element[20] = this.num_to_many(element[20]);
              element[21] = this.num_to_many(element[21]);
              element[22] = this.num_to_many(element[22]);
              element[23] = this.num_to_many(element[23]);
              element[24] = this.num_to_many(element[24]);
              element[25] = this.num_to_many(element[25]);
              this.tbv.row.add(element);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/pixMovimientos/index.js